<template>
  <div class="main-content">
    <md-layout
      md-flex
      v-if="!hasLoaded"
    >
      <md-progress md-indeterminate></md-progress>
      <span class="md-body-1">Carregando dados da aplicação...</span>
    </md-layout>
    <check-requisites v-on:onRequisitesCheck="onRequisitesCheck"></check-requisites>
    <div v-if="meetRequisites">
      <md-layout
        md-column
        v-if="!blh"
        class="start-process"
      >
        <!-- <span class="md-title"><b>Atenção!</b> Usuário possui acesso a mais de um BLH.</span> -->
        <span class="md-title">Selecione o BLH antes de prosseguir</span>
        <md-input-container>
          <label for="select-userBlhs">Banco de Leite Humano</label>
          <md-select
            v-model="selectedBLH"
            name="select-userBlhs"
            id="select-userBlhs"
          >
            <md-option
              v-for="(blh, index) in userBlhs"
              :key="blh.id"
              :value="index"
            >{{blh.name}}</md-option>
          </md-select>
        </md-input-container>
        <md-button
          class="md-primary md-raised"
          @click="setActiveBLH"
        >PROSSEGUIR</md-button>
      </md-layout>
      <md-layout
        md-column
        v-else-if="!certificationProcess && blh"
        class="start-process"
      >
        <span class="md-title">Olá <b>{{blh.name}}</b>, seja bem vindo ao</span>
        <span class="md-title">PROCESSO DE CERTIFICAÇÃO {{blh.currentYear}}</span>
        <span class="md-caption">Antes de iniciar o processo, veja atentamente as instruções abaixo</span>
        <span class="md-caption">Atenção: lembre-se de reunir a planta e as informaçoes necessárias do {{blh.name}}</span>
        <md-button
          @click="startCertificationProcess()"
          class="md-raised md-primary"
        >INICIAR PROCESSO DE CERTIFICAÇÃO</md-button>
      </md-layout>
      <md-layout v-else>
        <md-tabs
          md-centered
          class="md-transparent"
          md-fixed
          ref="tabs"
          @change="changeHandler"
        >
          <md-tab
            md-label="INSTALAÇÕES"
            md-icon="layers"
            ref="tabAreas"
            :md-active="isAreaActive"
            :md-disabled="certificationProcess.status >= 6"
          >
            <area-definitions></area-definitions>
          </md-tab>
          <md-tab
            md-label="Fotos"
            md-icon="camera_alt"
            :md-disabled="certificationProcess.status < 4 || certificationProcess.status >= 6"
            :md-active="isPhotoActive"
            ref="tabFotos"
          >
            <photos-list v-if="isPhotoActive"></photos-list>
          </md-tab>
          <md-tab
            md-label="Revisão"
            md-icon="visibility"
            :md-disabled="certificationProcess.status < 5 || certificationProcess.status >= 6 "
            :md-active="isReviewActive"
            ref="tabReview"
          >
            <md-layout md-column>
              <span>
                <p>Muito bem! Você preencheu todos as informações, agora é o momento de revisar, fique à vontade, verifique todas as informações e assim que estiver tudo pronto, clique no botão abaixo.</p>
                <p>IMPORTANTE! Após esta etapa não será possível alterar os dados da certificação</p>
              </span>
              <md-button
                class="md-accent md-raised"
                @click="startSync()"
              >SUBMETER DADOS DE CERTIFICAÇÃO</md-button>
            </md-layout>
          </md-tab>
          <md-tab
            md-label="Submeter"
            md-icon="backup"
            :md-disabled="certificationProcess.status < 6"
            :md-active="isSubmitActive"
            ref="tabSyncronization"
          >
            <sync-queue v-if="isSubmitActive"></sync-queue>
          </md-tab>
        </md-tabs>
      </md-layout>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import AreaDefinitions from '@/components/AreaDefinitions'
import PhotosList from '@/components/PhotosList'
import SyncQueue from '@/views/SyncQueue'
import CheckRequisites from '@/components/CheckRequisites'
export default {
  name: 'home',
  components: {
    AreaDefinitions,
    PhotosList,
    SyncQueue,
    CheckRequisites
  },
  computed: {
    ...mapState({
      uid: state => state.uid,
      blh: state => state.blh,
      step: state => state.step,
      certificationProcess: state => state.certificationProcess,
      isAreaActive: state => state.step === 0,
      isPhotoActive: state => state.step === 1,
      isReviewActive: state => state.step === 2,
      isSubmitActive: state => state.step === 3
    })
  },
  data: () => {
    return {
      index: 0,
      hasLoaded: false,
      userBlhs: [],
      selectedBLH: null,
      meetRequisites: false
    }
  },
  beforeMount () {
    let vm = this
    // Fetch user blhs and check if it has more than one, let him choose wich blh he wants to manage
    vm.FETCH_USER_BLHS().then((blhs) => {
      if (!blhs) {
        // user has no blh access
      } else {
        if (blhs.length > 1) {
          // user has more than one blh access
          vm.userBlhs = blhs
          vm.hasLoaded = true
        } else {
          vm.userBlhs = blhs
          vm.SET_BLH({ blh: vm.userBlhs[0] }).then(() => {
            vm.FETCH_DATA().then(() => {
              vm.hasLoaded = true
            })
          })
        }
      }
    })
  },
  methods: {
    ...mapActions(['FETCH_DATA', 'GOTO_STEP', 'SET_PROCESS', 'CREATE_PROCESS', 'FETCH_USER_BLHS', 'SET_BLH']),
    setActiveBLH () {
      let vm = this
      this.SET_BLH({ blh: this.userBlhs[this.selectedBLH] }).then(() => {
        vm.FETCH_DATA().then(() => {
          vm.hasLoaded = true
        })
      })
    },
    // checkQuota () {
    //   let vm = this
    //   navigator.webkitTemporaryStorage.queryUsageAndQuota(
    //     function (usedBytes, grantedBytes) {
    //       console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes')
    //       if (grantedBytes - usedBytes <= 4000000) {
    //         console.log('TAMANHO INSUFICIENTE PARA PROSSEGUIR COM O PROCESSO')
    //         vm.quotaExceeded = true
    //       } else {
    //         // vm.quotaExceeded = false
    //       }
    //     },
    //     function (e) {
    //       console.log('Error', e)
    //       vm.quotaExceeded = true
    //     }
    //   )
    // },
    changeHandler (index) {
      if (index === this.index) {
        return
      }
      this.index = index
      if (!this.$refs.tabs) return
      let tabs = this.$refs.tabs
      if (!tabs.activeTab) return
      if (!tabs.tabList.hasOwnProperty(tabs.activeTab)) return
      let activeTab = tabs.tabList[tabs.activeTab].ref
      if (!activeTab) return
      switch (activeTab) {
        case this.$refs.tabAreas:
          this.GOTO_STEP(0)
          break
        case this.$refs.tabFotos:
          this.GOTO_STEP(1)
          break
        case this.$refs.tabReview:
          this.GOTO_STEP(2)
          break
        case this.$refs.tabSyncronization:
          this.GOTO_STEP(3)
          break
        default:
          console.error('unknown tab:', activeTab)
      }
    },
    startCertificationProcess () {
      this.CREATE_PROCESS()
    },
    syncTemp () {
      this.$router.push('sync')
    },
    startSync () {
      this.$set(this.certificationProcess, 'status', 6)
      this.SET_PROCESS(this.certificationProcess).then(() => {
        this.GOTO_STEP(3)
      })
    },
    onRequisitesCheck (_meetRequisites) {
      this.meetRequisites = _meetRequisites
    }
    // checkRequisites () {
    //   if (!performance.memory) {
    //     // NO ACCESS TO PERFORMANCE CHECK
    //   } else {
    //     console.log(this.formatBytes(1000 * 1048576)) // 1GB
    //     console.log(this.formatBytes(performance.memory.jsHeapSizeLimit))
    //   }

    //   if (navigator.storage) {
    //     navigator.storage.estimate().then((storageResults) => {
    //       console.log('storage estimate:', this.formatBytes(storageResults.quota))
    //     })
    //   }

    //   if (navigator.userAgent) {
    //     console.log('chrome version:', navigator.userAgent)
    //   }
    // },
    // formatBytes (a, b) {
    //   if (a === 0) return '0 Bytes'
    //   var c = 1024
    //   var d = b || 2
    //   var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    //   var f = Math.floor(Math.log(a) / Math.log(c))
    //   return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
    // }
  }
}
</script>
<style scoped>
.start-process {
  margin: 10px;
  /* padding-left: 10%;
  padding-right: 30px;
  padding-top: 30px; */
}
</style>



// WEBPACK FOOTER //
// HomeView.vue?0d8ba132